import { createAppInstance } from './config/app';
import { initializeLogger } from './config/logger';
import { initApi } from './services/api';
import router from './router';
import { Capacitor } from '@capacitor/core';
import { setupDeepLinkListener } from '@/native/deepLink';

initializeLogger();

const { app } = createAppInstance();

app.use(router);

app.mount('#app');

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
initApi(API_BASE_URL);

if (Capacitor.isNativePlatform()) {
  setupDeepLinkListener();
}